import { CustomRouter } from "@utils/router";
import { ErrorRoutes } from './error/error.routes';
import { ValidarAssinaturaRoutes } from './validar-assinatura/validar-assinatura.routes';

const PUBLIC_ROUTES = ['erro', 'validar-assinatura'];

export class PublicPagesRouter {
    private static initialized = false;

    static initRouter() {
        if (PublicPagesRouter.initialized) {
            return;
        }

        PublicPagesRouter.initialized = true;

        CustomRouter.configRouter({
            mode: 'history'
        });

        ErrorRoutes.register(CustomRouter);
        ValidarAssinaturaRoutes.register(CustomRouter);

        CustomRouter.listen();
    }

    static isPublicRoute(pathname: string = window.location.pathname): boolean {
        const normalizedPath = PublicPagesRouter.normalizePath(pathname);

        return PUBLIC_ROUTES.includes(normalizedPath);
    }

    private static normalizePath(pathname: string): string {
        return pathname.replace(/^\/+|\/+$/g, '');
    }
}
